import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import useDrawer from "hooks/useDrawer";
import {selectRelatedIncidents} from "store/selectors/incidentOverviewSelectors";
import LinkedIncidentsDrawer from "./LinkedIncidentsDrawer";

const LinkedIncidents = () => {
  const {isOpen, open, close} = useDrawer();
  const linkedIncidents = useSelector((state) => selectRelatedIncidents(state));
  const {t} = useTranslation();

  return linkedIncidents?.length > 0 ? (
    <>
      <span className={"mx-1"}>{"-"}</span>
      <a
        role="button"
        onClick={() => (isOpen ? close() : open())}
        data-testid={"LinkedIncidents-Link-button"}>
        {t("incidentDetail.detail.linkedIncidents", {
          count: linkedIncidents?.length
        })}
      </a>
      <LinkedIncidentsDrawer
        isOpen={isOpen}
        onClose={close}
        linkedIncidents={linkedIncidents}
      />
    </>
  ) : null;
};

export default LinkedIncidents;
